import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { delayPacienteInmunoterapiaAplicacion } from "../services/inmunoterapia.service";

import { dangerNotification, successNotification } from '../../../redux/slices/ui';

export const usePacienteInmunoterapiaAplicacionPosponer = (id) => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const delayInmunoterapiaAplicacionMutation = useMutation({
        mutationFn: delayPacienteInmunoterapiaAplicacion,
        onSuccess: ({inmunoterapia, notificacion, msg, caducidad, limite}, variables, context) => {
            if(notificacion){
                variables.notificacion(msg);
            }else if(caducidad){
                variables.caducidad();
            }else if (limite){
                variables.limite();
            }else{
                variables.resetAccion();
                queryClient.invalidateQueries({ queryKey: ['paciente/inmunoterapia/proxima', id] });
                variables.success(inmunoterapia.aplicaciones);
                dispatch(successNotification('Aplicación pospuesta'));
            }
        },
        onError: (error, variables, context) => {
            // console.log(error);
            dispatch(dangerNotification(error.message));
        },
    });

    return {
        delayInmunoterapiaAplicacionMutation,
    }
}